import api, { getErrorMessage } from './api';

const scimService = {
  /**
   * Check whether a SCIM token exists for an organization
   * @param {string} orgId - Organization UUID
   * @returns {Promise<{has_token: boolean, scim_url: string}>}
   */
  getTokenStatus: async (orgId) => {
    try {
      const response = await api.get(`/api/v1/admin/scim/${orgId}/token`);
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Generate (or rotate) a SCIM bearer token for an organization.
   * The plaintext token is returned from the X-SCIM-Token response header.
   * @param {string} orgId - Organization UUID
   * @returns {Promise<{token: string, message: string}>}
   */
  generateToken: async (orgId) => {
    try {
      const response = await api.post(`/api/v1/admin/scim/${orgId}/token`);
      const token = response.headers['x-scim-token'];
      return { token, message: response.data.message };
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Revoke the SCIM bearer token for an organization
   * @param {string} orgId - Organization UUID
   * @returns {Promise<{message: string}>}
   */
  revokeToken: async (orgId) => {
    try {
      const response = await api.delete(`/api/v1/admin/scim/${orgId}/token`);
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default scimService;
